import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faPinterest,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faAt, faMobileScreen, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Tooltip } from "bootstrap";

const Entrepreneur = ({ data, index }) => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);

  return (
    <div className="row g-0 py-5 justify-content-center">
      {(index + 1) % 2 !== 0 && (
        <div className="col-lg-6 d-flex align-items-center">
          <div
            className={`add-img w-100 rounded-${(index + 1) % 2 !== 0 ? "start" : "end"} shadow-lg`}
            style={{ backgroundImage: `url(${data.images[0].url})`, aspectRatio: "4 / 5" }}
          />
        </div>
      )}
      <div className="col-lg-6 order-lg-1 order-2 d-flex align-items-center text-center">
        <div className="p-5 bg-white rounded-3 shadow">
          <h3>{data.name}</h3>
          <p>{data.description}</p>
          <div className="text-center">
            {(data.phone.length > 0 || data.mobilePhone.length > 0) && (
              <h4 className="text-center">Contacto</h4>
            )}
            <p className="text-center">
              {data.social.whatsapp && (
                <a
                  href={data.social.whatsapp}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Enviales un Whatsapp"
                >
                  <FontAwesomeIcon className="text-success fs-2" icon={faWhatsapp} />
                </a>
              )}
              {data.social.facebook && (
                <a
                  href={data.social.facebook}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visitar su página de facebook"
                >
                  <FontAwesomeIcon className="text-primary fs-2" icon={faFacebookF} />
                </a>
              )}
              {data.social.instagram && (
                <a
                  href={data.social.instagram}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de Instagram"
                >
                  <FontAwesomeIcon className="text-danger fs-2" icon={faInstagram} />
                </a>
              )}
              {data.social.linkedin && (
                <a
                  href={data.social.linkedin}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de LinkedIn"
                >
                  <FontAwesomeIcon className="text-primary fs-2" icon={faLinkedinIn} />
                </a>
              )}
              {data.social.twitter && (
                <a
                  href={data.social.twitter}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de X"
                >
                  <FontAwesomeIcon className="text-dark fs-2" icon={faXTwitter} />
                </a>
              )}
              {data.social.pinterest && (
                <a
                  href={data.social.pinterest}
                  className="btn btn-transparent text-reset text-decoration-none"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Visita su perfil de Pinterest"
                >
                  <FontAwesomeIcon className="text-danger fs-2" icon={faPinterest} />
                </a>
              )}
              {data.phone.length > 0 && (
                <>
                  <a
                    href={`tel:+${data.phone[0]}`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono fijo"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#0D47A1" }} icon={faPhone} />
                  </a>{" "}
                </>
              )}
              {data.mobilePhone.length > 0 && (
                <>
                  <a
                    href={`tel:+${data.mobilePhone[0]}`}
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Llamalos a su teléfono móvil"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                  </a>
                </>
              )}
              {data.email && (
                <>
                  <a
                    href="mailto:emailinfo@hashotelboutique.com"
                    className="btn btn-transparent text-reset text-decoration-none"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enviales un email"
                  >
                    <FontAwesomeIcon className="fs-2" style={{ color: "#FF9800" }} icon={faAt} />
                  </a>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
      {(index + 1) % 2 === 0 && (
        <div className="col-lg-6 order-lg-2 order-1 d-flex align-items-center">
          <div
            className={`add-img w-100 rounded-${(index + 1) % 2 !== 0 ? "start" : "end"} shadow-lg`}
            style={{ backgroundImage: `url(${data.images[0].url})`, aspectRatio: "4 / 5" }}
          />
        </div>
      )}
    </div>
  );
};

export default Entrepreneur;
